import { useLocation, useParams, Navigate } from "react-router-dom";
import ActivityForm from "../../../components/activity/ActivityForm";

const DuplicateActivity = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const activity = location.state?.activity;

  // If no activity data was passed, redirect to activities list
  if (!activity || !id) {
    return <Navigate to="/admin/activity" replace />;
  }

  // Append _1 to activity name for duplicate
  const duplicateActivityName = `${activity.activity_name}_1`;

  return (
    <ActivityForm
      initialData={{
        activityName: duplicateActivityName,
        patientGroup: activity.patient_group_id?.toString() || "",
        initialWorkflow: activity.workflow_id?.toString() || "",
      }}
      isDuplicate={true}
      sourceActivityId={parseInt(id)}
    />
  );
};

export default DuplicateActivity;
